"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteStudyNoticeResponse = exports.UpdateStudyNoticeResponse = exports.CreateStudyNoticeResponse = exports.GetStudyNoticeResponse = void 0;
class GetStudyNoticeResponse {
}
exports.GetStudyNoticeResponse = GetStudyNoticeResponse;
class CreateStudyNoticeResponse {
}
exports.CreateStudyNoticeResponse = CreateStudyNoticeResponse;
class UpdateStudyNoticeResponse {
}
exports.UpdateStudyNoticeResponse = UpdateStudyNoticeResponse;
class DeleteStudyNoticeResponse {
}
exports.DeleteStudyNoticeResponse = DeleteStudyNoticeResponse;
//# sourceMappingURL=studyNotice.js.map